import gql from "graphql-tag";

// eslint-disable-next-line import/no-default-export
export const GET_DOCUMENT_LIST = gql`
	query GetDocumentList(
		$before: String
		$after: String
		$first: Int
		$last: Int
		$where: DocumentListFilterInput
		$order: [DocumentListSortInput!]
		$status: DocumentStatus!
	) {
		documentList(
			before: $before
			after: $after
			first: $first
			last: $last
			where:
			{and : [
				{status: {eq:$status}}
				$where
				]}
			order: $order
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				id
				status
				category
				created
				from
				to
				description
				customer
				customerId,
				comment,
				newTask
			}
        }
	}
`;
